import { ArpMedia } from '@arpeggi/shared'
import { Box, Checkbox } from '@arpeggi/ui'
import { FC, useContext } from 'react'
import { FileCheckIcon } from '../../../../core/icons'
import Text from '../../../../core/Text/Text'
import { RowContainer } from '../../upload-sound-modal/MintSoundUploadPage'
import { SplitsTable } from '../primitives'
import { RegisterModalContext } from '../RegisterSongModal'

const SplitDetailsTableRow: FC<{
  subComponent: ArpMedia
  splitPercentage?: string
  isLastRow?: boolean
  selectable?: {
    onSelect: (subComponentId: number) => void
    onRemove: (subComponentId: number) => void
    isSelected: boolean
  }
}> = ({ subComponent, splitPercentage, isLastRow, selectable }) => {
  return (
    <RowContainer
      css={isLastRow ? { borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px' } : {}}
    >
      <SplitsTable.Column css={{ flex: 2, flexDirection: 'row' }}>
        <SplitsTable.ColumnContent
          css={{ alignItems: 'center', display: 'flex', flexDirection: 'row', gap: '8px' }}
        >
          {selectable ? (
            <Checkbox
              colorScheme="indigo"
              checked={selectable.isSelected}
              onCheckedChange={(checked) => {
                if (checked) {
                  selectable.onSelect(subComponent.id)
                } else {
                  selectable.onRemove(subComponent.id)
                }
              }}
            />
          ) : (
            <FileCheckIcon height="20px" width="20px" style={{ color: '#5EC271' }} />
          )}
          <Text overflowEllipsis>{subComponent.metadata.title}</Text>
        </SplitsTable.ColumnContent>
      </SplitsTable.Column>
      <SplitsTable.Column css={{ flex: 1 }}>
        <SplitsTable.ColumnContent>
          <Text overflowEllipsis>{subComponent.user.displayName}</Text>
        </SplitsTable.ColumnContent>
      </SplitsTable.Column>
      <SplitsTable.Column css={{ flex: 1 }}>
        <SplitsTable.ColumnContent>
          <Text overflowEllipsis>{subComponent.user.walletAddress}</Text>
        </SplitsTable.ColumnContent>
      </SplitsTable.Column>
      {splitPercentage && (
        <SplitsTable.Column css={{ flex: 1.5, alignItems: 'center', justifyContent: 'center' }}>
          <SplitsTable.ColumnContent>
            <Text>{splitPercentage}%</Text>
          </SplitsTable.ColumnContent>
        </SplitsTable.Column>
      )}
    </RowContainer>
  )
}

export const SplitDetailsTable: FC<{ subComponents: ArpMedia[] }> = ({ subComponents }) => {
  // TODO add real calculation
  const splitPercentage = ((0.2 / subComponents.length) * 100).toFixed(2)

  return (
    <Box>
      <SplitsTable.Header showSplits={false} />
      {subComponents.map((subComponent, index) => (
        <SplitDetailsTableRow
          key={subComponent.id}
          subComponent={subComponent}
          splitPercentage={splitPercentage}
          isLastRow={index === subComponents.length - 1}
        />
      ))}
    </Box>
  )
}

export const ConfirmSoundsTable: FC = () => {
  const { state, addSelectedSubComponent, removeSelectedSubComponent } =
    useContext(RegisterModalContext)

  return (
    <Box>
      <SplitsTable.Header showSplits={false} />
      {state.sounds.map((sound, index) => (
        <SplitDetailsTableRow
          key={sound.id}
          subComponent={sound}
          isLastRow={index === state.sounds.length - 1}
          selectable={{
            onSelect: addSelectedSubComponent,
            onRemove: removeSelectedSubComponent,
            isSelected: state.selectedSubComponentIds.includes(sound.id)
          }}
        />
      ))}
    </Box>
  )
}
